import Select from "react-select";
import { Col, Container, FormGroup, Input, Label, Row } from "reactstrap";
import { Modal } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import { getFundByAmc, getFunds } from "../../stores/services/funds.service";
import { useSelector } from "react-redux";
import NumberFormat from "react-number-format";
import moment from "moment";
import { useHistory } from "react-router-dom";
import {
  addLoanApplication,
  getAllProvidentFunds,
  getAllProvidentFundsByFolioAndFund,
} from "../../stores/services/provident-funds.service";
import { numberWithCommas } from "../../utils/customFunction";
import CardColComponent from "../genericCardComponent/CardColComponent";
import { getAllCompanies } from "../../stores/services/company.service";
import { GoAlert } from "react-icons/go";
import { getAccountByFund } from "../../stores/services/account.service";
import { getNewChartsOfAccountsByFund } from "../../stores/services/chatofaccounts.service";
import { getLedgerAccounts } from "../../utils/customFunction";
import React, { useEffect, useState } from "react";
import { useCustomStylesDropDown } from "../../assets/css/customStyle";

function LoanApplicationForm() {
  const history = useHistory();
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const email = sessionStorage.getItem("email") || "";
  const amcCode = sessionStorage.getItem("amc_code") || "";
  const period = sessionStorage.getItem("active_period") || "";
  const [fundCode, setFundCode] = useState("");
  const [loanAmount, setLoanAmount] = useState("");
  const [installments, setInstallments] = useState("");
  const [tableData, setTableData] = useState<any>([]);
  const [allPFFunds, setAllPFFunds] = useState<any>([]);
  const [allFolios, setAllFolios] = useState<any>([]);
  const [folio, setFolio] = useState<any>("");
  const [loanAmountLimit, setLoanAmountLimit] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [btnloading, setBtnloading] = useState<boolean>(false);
  const [loanRefundable, setLoanRefundable] = useState(false);
  const [loanApplicableData, setLoanApplicableData] = useState<any>({
    employee_loan_applicable: 0,
    employer_loan_applicable: 0,
    total_loan_applicable: 0,
  });
  const [summaryData, setSummaryData] = useState<any>([]);
  const [loadingCompany, setLoadingCompany] = useState(false);
  const [companyOptions, setCompanyOptions] = useState<any[]>([]);
  const [loanData, setLoanData] = useState<boolean>(false);
  const [companyName, setCompanyName] = useState<any>();
  const [warningModal, setWarningModal] = useState<boolean>(false);
  const [fundAccountsMap, setFundAccountsMap] = useState<{
    [key: string]: any[];
  }>({});
  const [fundAccount, setFundAccount] = useState<any>();
  const [chartOfAccounts, setChartOfAccounts] = useState<any>([]);
  const [counterFundLoading, setCounterFundLoading] = useState(false);
  const { customStyles } = useCustomStylesDropDown();

  // Fetch Companies
  useEffect(() => {
    const fetchAllCompanies = async () => {
      try {
        setLoadingCompany(true);
        const resp = await getAllCompanies({ email, fetch_all: "all" });
        if (resp.data.status === 200) {
          const options = resp.data.data.map((data: any) => ({
            ...data,
            value: data.company_code,
            label: `${data.name_of_company} (${data.company_code})`,
          }));
          setCompanyOptions(options);
        }
      } catch (error) {
        toast.error("Failed to load companies");
      } finally {
        setLoadingCompany(false);
      }
    };
    fetchAllCompanies();
  }, []);

  // Fetch Chart of Accounts for the fund
  const getCounterFundAccountByFundName = async (fund_code: string) => {
    setCounterFundLoading(true);
    try {
      let response = await getNewChartsOfAccountsByFund(
        email,
        amcCode,
        fund_code
      );
      if (response.data.status === 200) {
        setChartOfAccounts(response?.data?.data?.main_family);
      }
    } catch (error) {
      console.error("Error fetching chart of accounts", error);
    } finally {
      setCounterFundLoading(false);
    }
  };

  //  Auto-select Collection account
  const findCollectionAccount = (accounts: any[]) => {
    const collectionAccount = accounts.find(
      (acc) =>
        acc.account_purpose &&
        Array.isArray(acc.account_purpose) &&
        acc.account_purpose.includes("Loan")
    );
    setFundAccount(collectionAccount);
  };

  //  Fetch accounts for a specific fund
  const fetchAccountsForFund = async (fundCode: string) => {
    try {
      const res = await getAccountByFund(email, fundCode, amcCode);

      const accounts = res.data.data.map((acc: any) => ({
        value: acc.account_code,
        label: `${acc.account_title} - ${acc.account_no}`,
        account_no: acc.account_no,
        account_title: acc.account_title,
        account_purpose: acc.account_purpose || [],
        ...acc,
      }));

      setFundAccountsMap((prev) => ({
        ...prev,
        [fundCode]: accounts,
      }));

      findCollectionAccount(accounts);
      return accounts;
    } catch (err: any) {
      toast.error(
        err?.response?.data?.message ||
          `Failed to load accounts for fund ${fundCode}`
      );
      return [];
    }
  };

  // Fetch Funds when Company changes
  useEffect(() => {
    const getAllFunds = async () => {
      if (!companyName?.value) return;
      try {
        const res = await getFunds({
          email,
          company_name: companyName.value,
        });
        setAllPFFunds(res.data.data || []);
      } catch (error) {
        toast.error("Failed to load funds");
      }
    };
    getAllFunds();
  }, [companyName]);

  const getAllEmployees = async (fundIs) => {
    try {
      if (!fundIs) {
        setAllFolios([]);
        return;
      }
      const response = await getAllProvidentFunds(email, amcCode, fundIs);
      if (response.data.status == 200) {
        let dataIs = response?.data?.data;
        let seen = new Set();
        const filteredArr = dataIs?.filter((el) => {
          const duplicate = seen?.has(el?.folio_no);
          seen.add(el?.folio_no);
          return !duplicate;
        });
        setAllFolios(filteredArr);
      }
    } catch (error) {}
  };

  const searchData = async (folioIs) => {
    try {
      setLoading(true);
      const response = await getAllProvidentFundsByFolioAndFund(
        email,
        amcCode,
        fundCode,
        folioIs
      );
      if (response.data.status === 200 && response.data.data?.length) {
        let dataIs = response?.data?.summary;
        setTableData(response?.data?.data);
        let calEmployee: any =
          ((+selectedFund?.employee_contribution || 0) / 100) *
          +dataIs?.totalEmployeeContribution;
        let calEmployer: any =
          ((+selectedFund?.employer_contribution || 0) / 100) *
          +dataIs?.totalEmployerContribution;
        let limitIs: any = (+calEmployee || 0) + (+calEmployer || 0);
        setLoanAmountLimit(parseFloat(limitIs)?.toFixed(4));

        const PFfundDetailsArr = [
          {
            title: "Total Employee Cont",
            value: dataIs?.totalEmployeeContribution || 0,
            isAmount: true,
            fixed: 2,
          },
          {
            title: "Total Employer Cont",
            value: dataIs?.totalEmployerContribution || 0,
            isAmount: true,
            fixed: 2,
          },
          {
            title: "Total Profit",
            value: dataIs?.totalProfit || 0,
            isAmount: true,
            fixed: 2,
          },
          {
            title: "Total Amount",
            value: dataIs?.netTotal,
            isAmount: true,
            fixed: 2,
          },
        ];
        setSummaryData(PFfundDetailsArr);

        setLoanApplicableData({
          employee_loan_applicable: calEmployee || 0,
          employer_loan_applicable: calEmployer || 0,
          total_loan_applicable: limitIs || 0,
        });
        setLoanData(false);
      } else if (response.data.status === 409) {
        let loanData: any = response?.data?.loan_data[0];
        setLoanRefundable(loanData?.loan_refundable);
        setLoanAmount(loanData?.loan_amount?.toString());
        setInstallments(loanData?.number_of_installment?.toString());

        setLoanData(true);
        let dataIs = response?.data?.summary;
        setTableData(response?.data?.data);
        let calEmployee: any =
          ((+selectedFund?.employee_contribution || 0) / 100) *
          +dataIs?.totalEmployeeContribution;
        let calEmployer: any =
          ((+selectedFund?.employer_contribution || 0) / 100) *
          +dataIs?.totalEmployerContribution;
        let limitIs: any = (+calEmployee || 0) + (+calEmployer || 0);
        setLoanAmountLimit(parseFloat(limitIs)?.toFixed(4));

        const PFfundDetailsArr = [
          {
            title: "Total Employee Cont",
            value: dataIs?.totalEmployeeContribution || 0,
            isAmount: true,
            fixed: 2,
          },
          {
            title: "Total Employer Cont",
            value: dataIs?.totalEmployerContribution || 0,
            isAmount: true,
            fixed: 2,
          },
          {
            title: "Total Profit",
            value: dataIs?.totalProfit || 0,
            isAmount: true,
            fixed: 2,
          },
          {
            title: "Total Amount",
            value: dataIs?.netTotal,
            isAmount: true,
            fixed: 2,
          },
        ];
        setSummaryData(PFfundDetailsArr);

        setLoanApplicableData({
          employee_loan_applicable: calEmployee || 0,
          employer_loan_applicable: calEmployer || 0,
          total_loan_applicable: limitIs || 0,
        });
        toast.error(response?.data?.message);
      } else {
        toast.error("No record found!");
        setTableData([]);
        setLoanAmountLimit("");
      }
    } catch (error: any) {
      setTableData([]);
      setLoanData(false);
      setLoanAmountLimit("");
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  const renderFundsDropdown = () => {
    return allPFFunds?.map((item: any, index: string) => {
      return {
        _id: item?._id,
        value: item.symbol_code,
        label: `${item.fund_name} (${item.symbol_code})`,
      };
    });
  };

  const renderAllEmployeeDropdown = () => {
    return allFolios.map((item: any, index: number) => {
      return {
        _id: item?._id,
        label: `${item?.folio_no} - (${item?.employee_name})`,
        value: item?.folio_no,
      };
    });
  };

  useEffect(() => {
    if (fundCode) {
      fetchAccountsForFund(fundCode);
      getCounterFundAccountByFundName(fundCode);
    }
  }, [fundCode]);

  const selectedFund: any = React.useMemo(() => {
    const selectedFund =
      allPFFunds && allPFFunds?.find((item) => item.symbol_code === fundCode);
    return selectedFund
      ? {
          value: selectedFund.symbol_code,
          label: `${selectedFund.fund_name} (${selectedFund.symbol_code})`,
          employee_contribution: selectedFund?.employee_contribution,
          employer_contribution: selectedFund?.employer_contribution,
          loan_installement_limit: selectedFund?.loan_installement,
        }
      : null;
  }, [fundCode, allPFFunds]);

  const selectedFolioVal: any = React.useMemo(() => {
    const selected = allFolios?.find((item) => item?.folio_no === folio);
    return selected
      ? {
          label: `${selected?.folio_no} - (${selected?.employee_name})`,
          value: selected?.folio_no,
          unitholder_name: selected?.employee_name,
        }
      : null;
  }, [allFolios, folio]);

  // Helper function to get ledger info by code
  const getLedgerInfoByLedgerCode = (coa, ledgerCode) => {
    let obj = {};
    const ledgers = coa.map((item: any) => {
      let familyData = item.family;
      const family = familyData.map((familyF: any) => {
        let subData = familyF.sub_family;
        const subFamily = subData.map((subfamily: any) => {
          if (subfamily.child_family !== undefined) {
            let child_family = subfamily.child_family;
            const childFamilyData = child_family.map((itm: any) => {
              let gl = itm.gl;
              const glData = gl.map((glItem: any) => {
                if (Number(glItem.code) === Number(ledgerCode)) {
                  obj = {
                    gl_code: glItem.code,
                    gl_name: glItem.name,
                    sub_family_code: subfamily.code,
                    sub_family_name: subfamily.name,
                    main_family_code: item.code,
                    main_family_name: item.name,
                    family_code: familyF.code,
                    family_name: familyF.name,
                    child_family_code: itm.code,
                    child_family_name: itm.name,
                  };
                }
              });
            });
          } else {
            let gl = subfamily.gl;
            const glData = gl.map((glItem: any) => {
              if (Number(glItem.code) === Number(ledgerCode)) {
                obj = {
                  gl_code: glItem.code,
                  gl_name: glItem.name || glItem.account_title,
                  sub_family_code: subfamily.code,
                  sub_family_name: subfamily.name,
                  main_family_code: item.code,
                  main_family_name: item.name,
                  family_code: familyF.code,
                  family_name: familyF.name,
                  child_family_code: 0,
                  child_family_name: "",
                };
              }
            });
          }
        });
      });
    });
    return obj;
  };

  const handleSubmit = async () => {
    try {
      setBtnloading(true);

      // Validate fund account
      fundAccount.code = fundAccount.gl_code;

      if (!fundAccount || !fundAccount.gl_code) {
        toast.error("Please select a fund account");
        setBtnloading(false);
        return;
      }

      let amount_per_installment: any = "";
      if (loanAmount && installments) {
        let value: any = +loanAmount / +installments;
        let floatValue = parseFloat(value)?.toFixed(4);
        amount_per_installment = floatValue;
      }

      const dateStr = moment().format("YYYY-MM-DD");
      const loanAmountNum = Number(loanAmount);

      // GL Codes
      const loan_gl_code = 10208030701; // Loan GL Code (Debit)
      const bank_gl_code = fundAccount.code; // Bank GL Code (Credit)

      let txnLedgers: any[] = [];

      // Create ledger entry helper
      const createLedgerEntry = (code, type, amount, description) => {
        const info: any = getLedgerInfoByLedgerCode(chartOfAccounts, code);
        return {
          main_family_code: info?.main_family_code || "",
          main_family_name: info?.main_family_name || "",
          family_code: info?.family_code || "",
          family_name: info?.family_name || "",
          sub_family_code: info?.sub_family_code || "",
          sub_family_name: info?.sub_family_name || "",
          child_family_code: info?.child_family_code || "",
          child_family_name: info?.child_family_name || "",
          gl_code: info?.gl_code || code,
          gl_name: info?.gl_name || "",
          amount_type: description,
          type: type,
          amc_code: amcCode,
          fund_code: fundCode,
          account_number: type === "Credit" ? fundAccount.account_no : "",
          account_title: type === "Credit" ? fundAccount.account_title : "",
          bank_code: type === "Credit" ? fundAccount.bank : "",
          branch: type === "Credit" ? fundAccount.branch : "",
          balance: "",
          counter_account_number: "",
          counter_account_title: "",
          counter_bank: "",
          counter_branch: "",
          credit_amount: type === "Credit" ? amount.toFixed(4) : "0",
          debit_amount: type === "Debit" ? amount.toFixed(4) : "0",
          description: `${description} - ${dateStr}`,
          entered_by: email,
          evidence: "",
          instruction_date: dateStr,
          instrument_by: "",
          instrument_date: dateStr,
          instrument_no: "",
          instrument_type: "",
          realized: "true",
          realized_by: email,
          realized_date: dateStr,
          period: period,
        };
      };

      // Create ledgers only if chart of accounts is loaded
      if (chartOfAccounts.length > 0) {
        // Debit: Loan Account (Asset increases)
        txnLedgers.push(
          createLedgerEntry(
            loan_gl_code,
            "Debit",
            loanAmountNum,
            "Loan Disbursement"
          )
        );

        // Credit: Bank Account (Asset decreases)
        txnLedgers.push(
          createLedgerEntry(
            bank_gl_code,
            "Credit",
            loanAmountNum,
            "Loan Payment"
          )
        );
      }

      // Create transaction object
      const txn_obj = {
        email: email,
        txnr_type: "loanapplication",
        amc_code: amcCode,
        fund_code: fundCode,
        instruction_date: dateStr,
        execution_date: dateStr,
        executed_date: dateStr,
        fund_account: fundAccount?.code?.toString() || "",
        reinvest: false,
        account_title: fundAccount?.account_title || "",
        period: period,
        account_no: fundAccount?.account_no || "",
        bank: fundAccount?.bank || "",
        branch: fundAccount?.branch || "",

        // Counter account fields
        counter_account_type: "",
        counter_type: "",
        counter_account_title: selectedFolioVal?.unitholder_name || "",
        counter_account_number: folio || "",
        counter_bank: "",
        counter_branch: "",

        // Payment details
        mode_of_payment: "Bank Transfer",
        payment_type: "Payment",
        instrument_no: "",
        instrument_type: "",
        instrument_date: dateStr,

        // Realization details
        realized_date: dateStr,
        realized: true,

        // Amount fields
        gross_amount: loanAmountNum,
        total_charges: 0,
        txn_charges: 0,
        net_amount: loanAmountNum,

        // Ledgers
        ledgers: JSON.stringify(txnLedgers),

        // Settlement details
        settlement_date: dateStr,
        settlement_by: email,

        // Status
        txn_status: "CREATED",

        // Additional metadata
        detail: `Loan Application - Employee: ${
          selectedFolioVal?.unitholder_name
        }, Folio: ${folio}, Amount: ${loanAmountNum.toFixed(
          2
        )}, Installments: ${installments || "N/A"}`,
      };

      const response = await addLoanApplication(
        email,
        companyName?.value,
        fundCode,
        selectedFund?.label || "",
        folio,
        selectedFolioVal?.unitholder_name || "",
        Number(loanAmount),
        Number(installments),
        0,
        loanApplicableData?.total_loan_applicable || 0,
        loanApplicableData?.employee_loan_applicable || 0,
        loanApplicableData?.employer_loan_applicable || 0,
        Boolean(loanRefundable),
        Number(amount_per_installment || 0),
        txn_obj // Pass transaction object
      );

      if (response.data.status == 200) {
        toast.success("Loan Application Added!");
        setTimeout(() => {
          history.push("/admin/loan-applications");
        }, 1000);
      } else {
        toast.error("Error Creating Loan Application!");
      }
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message || "Error creating loan application"
      );
    } finally {
      setBtnloading(false);
    }
  };

  const toFixed4Decimal = (value) => {
    let ValueIs = parseFloat(value || 0)?.toFixed(4);
    return numberWithCommas(ValueIs);
  };

  const resetFields = () => {
    setTableData([]);
    setLoanAmount("");
    setInstallments("");
  };
  return (
    <div className="content">
      {/* ------------------------  Alert Modal ------------------ */}
      <Modal
        className=""
        dialogClassName="modal90w"
        show={warningModal ? true : false}
        size="xl"
        backdrop={true}
        onHide={() => {
          setWarningModal(false);
        }}
        centered={true}
      >
        <div className="modal-header">
          <button
            aria-hidden={true}
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => {
              setWarningModal(false);
            }}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
          <h6 className="title title-up">Confirmation</h6>
        </div>
        <div className="modal-body">
          <div className="text-center py-4">
            <GoAlert
              style={{
                width: "48px",
                height: "48px",
                color: "#ffc107",
              }}
            />
            <h4 className="mt-3 mb-3">Confirm Loan Application Decision</h4>
            <p className="text-muted mb-4">
              The installment amount exceeds the threshold of{" "}
              <span className="text-danger">
                {+selectedFund?.loan_installement_limit}
              </span>
              . Are you sure you want to proceed?
            </p>

            <div className="d-flex justify-content-center gap-3 mt-4">
              <button
                className="btn btn-success btn-lg px-5"
                onClick={() => {
                  handleSubmit();
                }}
              >
                <i className="tim-icons icon-check-2 mr-2" />
                Confirm
              </button>

              <button
                className="btn btn-danger btn-lg px-5"
                onClick={() => {
                  setWarningModal(false);
                }}
              >
                <i className="tim-icons icon-simple-remove mr-2" />
                Cancel
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <Row>
        <Col md="12">
          <Container fluid>
            <ToastContainer limit={1} />
            <div className="card">
              <div className="d-flex align-items-center"></div>
              <div className="">
                <div className="card-header">
                  <div className="card-title">
                    <h4 className="d-flex justify-content-between align-items-center">
                      Loan Application 💸
                      <button
                        className="btn btn-primary btn-sm float-right"
                        onClick={() => {
                          history.push("/admin/loan-applications");
                        }}
                      >
                        <i className="fa fa-eye mr-2"></i> View All
                      </button>
                    </h4>
                  </div>
                </div>
                <div className="card-body">
                  <div className="">
                    {/* --- Dropdown Section --- */}
                    <div className="row ">
                      <Col className="form-group col-md-3">
                        <label>
                          Company Name <span className="color-amber">*</span>
                        </label>
                        <Select
                          className="react-select info"
                          isLoading={loadingCompany}
                          value={companyName}
                          onChange={setCompanyName}
                          menuPortalTarget={document.body}
                          menuShouldBlockScroll
                          isClearable
                          isSearchable
                          options={companyOptions}
                          styles={customStyles}
                        />
                      </Col>

                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Select Fund</label>
                          <Select
                            value={selectedFund}
                            label={"Select Fund"}
                            onChange={(e) => {
                              resetFields();
                              setFundCode(e?.value);
                              setAllFolios(
                                allFolios?.filter(
                                  (ele) => ele?.symbol_code === e?.value
                                )
                              );
                              getAllEmployees(e?.value);
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                            isClearable={true}
                            isSearchable={true}
                            name="color"
                            options={renderFundsDropdown()}
                            styles={customStyles}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Select Employee</label>
                          <Select
                            value={selectedFolioVal}
                            label={"Select Folio"}
                            onChange={(e: any) => {
                              resetFields();
                              if (e?.value) {
                                searchData(e?.value);
                                setFolio(e?.value);
                              } else {
                                setTableData([]);
                                setFolio("");
                              }
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                            isClearable={true}
                            isSearchable={true}
                            name="color"
                            options={renderAllEmployeeDropdown()}
                            styles={customStyles}
                          />
                        </div>
                      </div>
                    </div>

                    <hr />

                    {/* --- Table Section --- */}
                    {loading ? (
                      <div className="d-flex justify-content-center my-5">
                        <i
                          className="fa fa-spinner fa-spin fa-3x"
                          aria-hidden="true"
                        ></i>
                      </div>
                    ) : !loading && tableData?.length > 0 ? (
                      <>
                        <h3 className="mb-3">
                          Employee Contribution Details 📊
                        </h3>
                        <Row>
                          <Col xs={12}>
                            <div className={"card shadow-sm m-1 p-2 small"}>
                              <div
                                className={
                                  "shadow card-header py-2 px-3 border-bottom"
                                }
                              >
                                <div className={" d-flex align-items-center"}>
                                  <span>Total Contribution</span>
                                </div>
                              </div>
                              <div
                                className={`${
                                  theme == "dark" ? "text-white" : ""
                                } card-body p-2`}
                              >
                                <div className="d-flex flex-wrap">
                                  {summaryData?.map((item: any, i) => (
                                    <div
                                      className="flex-item pr-5 pb-3"
                                      key={i}
                                    >
                                      <CardColComponent
                                        title={item?.title}
                                        subTitle={numberWithCommas(
                                          parseFloat(item?.value ?? 0)?.toFixed(
                                            item?.fixed
                                          )
                                        )}
                                        amount={item?.isAmount}
                                      />
                                    </div>
                                  ))}
                                </div>
                                <div className="table-responsive">
                                  <table className="table table-striped table-bordered table-hover">
                                    <thead>
                                      <tr>
                                        <th className="px-0">Fund Code</th>
                                        {/* <th>Month</th> */}
                                        <th className="px-0">Employee Code</th>
                                        <th className="px-0">Employee Name</th>
                                        <th className="px-0">CNIC</th>
                                        {/* <th>Employee Contribution</th> */}
                                        {/* <th>Employer Contribution</th> */}
                                        {/* <th>Profit</th> */}
                                        {/* <th>Total</th> */}
                                        <th className="px-0">Remarks</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {tableData?.map((data, index) => (
                                        <tr key={index}>
                                          <td>{data?.symbol_code}</td>
                                          {/* <td>{moment(data?.month_of_contribution)?.format("DD-MM-YYYY")}</td> */}
                                          <td>{data?.folio_no}</td>
                                          <td>{data?.employee_name}</td>
                                          <td>{data?.employee_cnic}</td>
                                          {/* <td>{numberWithCommas(data?.employee_contribution)}</td> */}
                                          {/* <td>{numberWithCommas(data?.employer_contribution)}</td> */}
                                          {/* <td>{numberWithCommas(data.profit)}</td> */}
                                          {/* <td>{numberWithCommas(data.total)}</td> */}
                                          <td>{data.remarks}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <hr />

                        {/* --- Apply for Loan Card Section --- */}
                        <h3 className="mb-3">
                          <div className="d-flex justify-content-between align-items-center">
                            {loanData ? "Loan Taken Details" : "Apply for Loan"}{" "}
                            📝
                            <div className="form-group">
                              <FormGroup
                                disabled={loanData}
                                check
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                  alignItems: "center",
                                }}
                              >
                                <Label check>
                                  <Input
                                    type="checkbox"
                                    checked={loanRefundable}
                                    disabled={loanData}
                                    onChange={(e) => {
                                      setLoanRefundable((prev) =>
                                        prev === false ? true : false
                                      );
                                      setInstallments("");
                                    }}
                                  />
                                  <span className="form-check-sign" />
                                  Refundable Loan
                                </Label>
                              </FormGroup>
                            </div>
                          </div>
                        </h3>
                        <div className="card shadow-sm border-primary">
                          <div className="card-body">
                            <div className="row mb-2">
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>
                                    Loan Applicable From Employee Contribution
                                  </label>
                                  <input
                                    type="text"
                                    className={`form-control w-100 `}
                                    value={toFixed4Decimal(
                                      loanApplicableData?.employee_loan_applicable
                                    )}
                                    readOnly
                                  />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>
                                    Loan Applicable From Employer Contribution
                                  </label>
                                  <input
                                    type="text"
                                    className={`form-control w-100 `}
                                    value={toFixed4Decimal(
                                      loanApplicableData?.employer_loan_applicable
                                    )}
                                    readOnly
                                  />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Total Loan Applicabale</label>
                                  <input
                                    type="text"
                                    className={`form-control w-100 `}
                                    value={toFixed4Decimal(
                                      loanApplicableData?.total_loan_applicable
                                    )}
                                    readOnly
                                  />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Loan Amount</label>
                                  <NumberFormat
                                    thousandSeparator
                                    decimalScale={4}
                                    isAllowed={(values) => {
                                      const { value } = values;
                                      let returnVal;
                                      if (
                                        (+value <= +loanAmountLimit &&
                                          +value > 0) ||
                                        value === ""
                                      ) {
                                        returnVal = true;
                                      } else {
                                        returnVal = false;
                                      }
                                      return returnVal;
                                    }}
                                    readOnly={loanData}
                                    onValueChange={({ value }) => {
                                      setLoanAmount(value);
                                    }}
                                    value={loanAmount}
                                    className={`form-control w-100`}
                                  />
                                </div>
                              </div>
                              {loanRefundable && (
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label className="d-flex justify-content-between align-items-center">
                                      Number of Installments
                                      <span
                                        style={{
                                          color: "#fb3d3d",
                                        }}
                                      >
                                        {+installments >
                                        +selectedFund?.loan_installement_limit
                                          ? "Limit Exceeded"
                                          : ""}
                                      </span>
                                    </label>
                                    <NumberFormat
                                      thousandSeparator
                                      decimalScale={0}
                                      isAllowed={(values) => {
                                        const { value } = values;
                                        let returnVal;
                                        if (
                                          (+value <= 100 && +value > 0) ||
                                          value === ""
                                        ) {
                                          returnVal = true;
                                        } else {
                                          returnVal = false;
                                        }
                                        return returnVal;
                                      }}
                                      readOnly={loanData}
                                      onValueChange={({ value }) => {
                                        setInstallments(value);
                                      }}
                                      value={installments}
                                      className={`form-control w-100 ${
                                        +installments >
                                        +selectedFund?.loan_installement_limit
                                          ? "required-border"
                                          : ""
                                      }`}
                                    />
                                  </div>
                                </div>
                              )}
                              {loanAmount && installments && (
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label>Per Installement</label>
                                    <input
                                      type="text"
                                      className={`form-control w-100 `}
                                      value={toFixed4Decimal(
                                        +loanAmount / +installments
                                      )}
                                      readOnly
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    ) : null}
                    {!loanData && (
                      <button
                        disabled={!loanAmount || btnloading}
                        className="btn btn-success "
                        onClick={() => {
                          if (
                            +installments >
                            +selectedFund?.loan_installement_limit
                          ) {
                            setWarningModal(true);
                          } else {
                            handleSubmit();
                          }
                        }}
                      >
                        Submit Loan Request
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </Col>
      </Row>
    </div>
  );
}

export default LoanApplicationForm;
